import { PackageTypeRouteT } from "./../../../models/models";
import { SelectedOptionE } from "../../../models/enums";

/**
 * Calculate page title key for translation
 */

const getPageTitleKey = (
  packageType: PackageTypeRouteT,
  periodType: SelectedOptionE
) => {
  if (packageType === "sub-users" || packageType === "extra-storage") {
    // Addons title
    return `${packageType}-purchase-title`;
  } else if (packageType === "pay-as-you-go") {
    // JUMBOcodes title
    return `Pay-As-You-Go - ${periodType} JUMBOcodes`;
  } else if (packageType === "purchase-failed") {
    return packageType;
  } else {
    return packageType + "-" + periodType + "-subscription";
  }
};

export default getPageTitleKey;
